import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@material-ui/core";
import {
  Info,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  infoIcon: {
    textAlign: "center",
    width: "110px",
  },
}));

function MediaAccounts(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [mediaAccounts, setMediaAccounts] = React.useState([]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 多メディア対応アカウント管理";

  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchMediaAccounts();
  }, [auth.state.token]);

  const fetchMediaAccounts = () => {
    request({
      method: "GET",
      url: `admin/accounts`,
    }).then((result) => {
      let mediaAccounts = [];
      // contract_type が Ruby（多メディア対応）のアカウントのみ取得
      (result.data.data).map(
        (account) => {
          if (account.options.media) {
            mediaAccounts.push(account);
          }
        }
      );
      
      setMediaAccounts(mediaAccounts);
    });
  };

  const onClickInfoButton = (id) => {
    props.history.push(`/admin/media/accounts/group/${id}`);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell className={classes.infoIcon}>
            <IconButton 
                color="primary" 
                aria-label="add an Info"
                onClick={() => onClickInfoButton(row.id)}
              >
                <Info />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                収集グループ一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>アカウント名</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mediaAccounts.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </>
      }
    />
  );
}

export default withRouter(MediaAccounts);
